/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImportTypeEnum,
    ImportTypeEnumFromJSON,
    ImportTypeEnumFromJSONTyped,
    ImportTypeEnumToJSON,
} from './ImportTypeEnum';

/**
 * 
 * @export
 * @interface ImporterDto
 */
export interface ImporterDto {
    /**
     * 
     * @type {ImportTypeEnum}
     * @memberof ImporterDto
     */
    id: ImportTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ImporterDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImporterDto
     */
    blacklist: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ImporterDto
     */
    isEnabled: boolean;
}

export function ImporterDtoFromJSON(json: any): ImporterDto {
    return ImporterDtoFromJSONTyped(json, false);
}

export function ImporterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImporterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': ImportTypeEnumFromJSON(json['id']),
        'description': json['description'],
        'blacklist': json['blacklist'],
        'isEnabled': json['isEnabled'],
    };
}

export function ImporterDtoToJSON(value?: ImporterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': ImportTypeEnumToJSON(value.id),
        'description': value.description,
        'blacklist': value.blacklist,
        'isEnabled': value.isEnabled,
    };
}

